/*
 *
 * App actions
 *
 */

import { createAction } from '@reduxjs/toolkit';
import appConstants from './constants';

export const defaultAction = createAction(
  appConstants.DEFAULT_ACTION,
  function prepare() {
    return { payload: {} };
  },
);

export const defaultActionSuccess = createAction(
  appConstants.DEFAULT_ACTION_SUCCESS,
  function prepare(data: any) {
    return { payload: { data } };
  },
);

export const defaultActionError = createAction(
  appConstants.DEFAULT_ACTION_ERROR,
  function prepare(error: any) {
    return { payload: { error } };
  },
);

export const toggleTheme = createAction(appConstants.TOGGLE_THEME);

export const setAppLoaded = createAction(appConstants.SET_APP_LOADED);

export const updateToken = createAction(
  appConstants.UPDATE_TOKEN,
  function prepare(token: string) {
    return { payload: token };
  },
);

export const logoutRequest = createAction(
  appConstants.LOGOUT_REQUEST,
  function prepare() {
    return { payload: {} };
  },
);

export const logoutSuccess = createAction(
  appConstants.LOGOUT_SUCCESS,
  function prepare() {
    return { payload: {} };
  },
);

export const logoutError = createAction(
  appConstants.LOGOUT_ERROR,
  function prepare(error: string) {
    return { payload: { error } };
  },
);

export const clearSession = createAction(
  appConstants.CLEAR_SESSION,
  function prepare() {
    return { payload: {} };
  },
);

export const changeLanguage = createAction(
  appConstants.CHANGE_LANGUAGE,
  function prepare(language: string) {
    return { payload: { language } };
  },
);

export const saveLanguagePreference = createAction(
  appConstants.SAVE_LANGUAGE_PREFERENCE,
  function prepare(language: string) {
    return { payload: { language } };
  },
);

export const saveLanguagePreferenceSuccess = createAction(
  appConstants.SAVE_LANGUAGE_PREFERENCE_SUCCESS,
  function prepare() {
    return { payload: {} };
  },
);

export const saveLanguagePreferenceError = createAction(
  appConstants.SAVE_LANGUAGE_PREFERENCE_ERROR,
  function prepare(error: string) {
    return { payload: { error } };
  },
);
